jQuery(document).ready(function ($) {
    var tooltipOpen = false;
    var toolTipTimeOut = null;
    $('.answer-response .icon--overlay-close').on('click',function(e){
        console.log('click 1');
        e.stopImmediatePropagation();
        $('.answer-tooltip').hide();
        $('.answer').removeClass('open');
    })
    $('#quiz, #quiz-questions-list').on('click','.answer',function(e){
        if ($(e.target).closest('a').length === 0) {
            // Prevent default only if the target is not an 'a' tag
            e.preventDefault();

            clearTimeout(toolTipTimeOut);
            $('.answer-tooltip').hide();
            $('.answer').removeClass('open');
            let tooltip = $(this).find('.answer-tooltip');
            $(tooltip).css('display', 'block');
            tooltipOpen = true;
            $(this).addClass('open');
            setTimeout(function(){tooltipOpen=false}, 100);
        }
        // console.log('click 2');
        // e.preventDefault();
        // clearTimeout(toolTipTimeOut);
        // $('.answer-tooltip').hide();
        // $('.answer').removeClass('open');
        // let tooltip = $(this).find('.answer-tooltip');
        // // if ($(window).width() <= 768) {
        //     $(tooltip).css('display', 'block');
        // // } else {
        // //     $(tooltip).show();
        // // }
        // tooltipOpen = true;
        // $(this).addClass('open');
        // setTimeout(function(){tooltipOpen=false},100);
        // // toolTipTimeOut = setTimeout(function(){tooltip.fadeOut(300)},3000);
    })
    $('#test').on('click','.toggle-answer',function(e){
        e.preventDefault();
        clearTimeout(toolTipTimeOut);
        $('.answer-tooltip').hide();
        let tooltip = $(this).parent().find('.answer-tooltip');
        $(tooltip).show();
        tooltipOpen = true;
        setTimeout(function(){tooltipOpen=false},100);
        // toolTipTimeOut = setTimeout(function(){tooltip.fadeOut(300)},3000);
    })
    $('body').on('click',function(){
        if(!tooltipOpen){
            $('.answer').removeClass('open');
            clearTimeout(toolTipTimeOut);
            $('.answer-tooltip').hide();
        }
    })

    $('.coaching').slideUp();
    // $('.coaching-toggle').on('click',function(e){
    //     e.preventDefault();
    //     $(this).toggleClass('active');
    //     let selectedCoaching = $('.coaching[data-coaching-id="'+$(this).attr('data-coaching-id')+'"]');
    //     let alreadySelected = selectedCoaching.is(":visible");
    //     $('.coaching').slideUp();
    //     if(!alreadySelected) {
    //         $('.coaching[data-coaching-id="' + $(this).attr('data-coaching-id') + '"]').slideDown();
    //     }
    // });

    //Toggle only one at a time
    // $('.coaching-toggle').on('click',function(e){
    //     e.preventDefault();
    //     let clickedButton = $(this);
    //     let coachingId = clickedButton.attr('data-coaching-id');
    //     let selectedCoaching = $('.coaching[data-coaching-id="' + coachingId + '"]');
    //     let alreadySelected = selectedCoaching.is(":visible");
    //
    //     $('.coaching-toggle').not(clickedButton).removeClass('active');
    //     $('.coaching-toggle').not(clickedButton).text('View Coaching');
    //
    //     clickedButton.toggleClass('active');
    //
    //     if (clickedButton.text() === 'View Coaching') {
    //         clickedButton.text('Hide Coaching');
    //     } else {
    //         clickedButton.text('View Coaching');
    //     }
    //
    //
    //     $('.coaching').slideUp();
    //     if(!alreadySelected) {
    //         $('.coaching[data-coaching-id="' + $(this).attr('data-coaching-id') + '"]').slideDown();
    //     }
    // });
    $('.coaching-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if($(this).hasClass('non-member')) {
            window.location.href = '/pro';
            return;
        }
        let clickedButton = $(this);
        let coachingId = clickedButton.attr('data-coaching-id');
        let selectedCoaching = $('.coaching[data-coaching-id="' + coachingId + '"]');

        clickedButton.toggleClass('active');

        if (clickedButton.hasClass('active')) {
            clickedButton.text('Hide Coaching');
        } else {
            clickedButton.text('View Coaching');
        }

        selectedCoaching.slideToggle();
    });

});

